import { __awaiter } from "tslib";
import { AppState } from '../etc/stores';
import { Container } from './container';
import { StatefulService } from './stateful-service';
export class FeatureFlag extends StatefulService {
    loadState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { items: featureFlags } = yield this.backend.getFeatureFlags();
            AppState.update(state => (Object.assign(Object.assign({}, state), { featureFlags })));
        });
    }
}
Container.add(FeatureFlag);
